import { Injectable } from "@angular/core";
import { IID_GENERIC_SUSPENSION } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDgenericSuspensionStore } from "./genericSuspension.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.GENERIC_SUSPENSION)
export class IIDgenericSuspensionQuery extends AbstractInterfaceDataQuery<IID_GENERIC_SUSPENSION> {
  constructor(protected store: IIDgenericSuspensionStore) {
    super(store);
  }
}
